import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsVideoPlayer from "../../components/LdsVideoPlayer";
import LdsFigureCaption from "../../components/LdsFigureCaption";
import LdsKalturaPlayer from "../../components/LdsVideoPlayer/KalturaPlayer";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.3.4 Demonstration Case 3: Low Contrast Negative
            </h1>
            <p className="me-4">Estimated time to complete: 3 minutes</p>
          </section>

          <section className="row justify-content-center">
            <div className="col-lg-8 col-sm-12 mt-4 mb-4">
              <LdsFigureCaption
                textContent={
                  <>
                    <p>
                      <strong>AUDIO</strong>
                      <br />
                      VO: (FEMALE)
                      <br />
                    </p>
                    <p>
                      This is Demonstration Case Number 3. This is a negative
                      case. The size and contrast have already been adjusted.
                    </p>
                    <p>
                      Starting in the cerebellum, you can identify the normal
                      gray-white contrast for this particular patient. The
                      cerebellum is also identified on the accompanying coronal
                      view. Returning to the transverse image and moving
                      superiorly, you enter into the temporal and occipital
                      regions. You can immediately identify increased noise on
                      this scan when compared to Demonstration Cases 1 and 2.
                      The speckled pattern identifiable on both sides of the
                      brain extending from the temporal lobes into the occipital
                      lobes.
                    </p>
                    <p>
                      Moving superiorly, we enter the frontal lobes. Again,
                      increased activity is seen in the white matter tracts, and
                      these finger-like projections are see extending into the
                      gray matter surrounding. This pattern is visible on both
                      the right and the left side. It is important to note that
                      the inferior-most aspect of the frontal lobes is a
                      transition zone. In this zone, delineation of white matter
                      tracts may be difficult. There may appear to be loss of
                      gray-white contrast in this zone as the result of volume
                      averaging. In order to identify the location of this
                      transition zone, utilize the sagittal images, as can be
                      seen here.
                    </p>
                    <p>
                      Please remember that loss of gray-white contrast must
                      occur in more than one slice and involve greater than one
                      cortical gyrus in order to be considered a positive
                      region. It is important to review all slices of the
                      frontal lobes to ensure that, in fact, white matter tracts
                      are easily identifiable, as can be see here. Therefore, in
                      this case, there is normal gray-white contrast. In
                      reviewing the remainder of the slices within the brain,
                      one can identify normal white matter tracts extending from
                      the anterior aspect all the way posteriorly. This pattern
                      is see on the right and the left. As we move even
                      superiorly, this pattern continues.
                    </p>
                    <p>
                      Looking at the medial parietal region, no increased
                      activity is seen in the precuneus and there is a normal
                      gray-white contrast here.
                    </p>
                    <p>
                      As this case has no areas of significant reduction in
                      gray-white contrast, this case is negative.
                    </p>
                  </>
                }
                buttonIcon="MinusCircle"
                buttonTextAlign="left"
                showDescriptionText="Video Transcript"
                hideDescriptionText="Video Transcript"
                radiusSize="small"
              >
                <LdsVideoPlayer brandBorder={false}>
                  <LdsKalturaPlayer
                    videoId="1_i8rop09o"
                    partnerId="1759891"
                    uiConfId="54959122"
                    nextUrl="/module-2/module-2-3-5"
                  />
                </LdsVideoPlayer>
              </LdsFigureCaption>
            </div>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-3-5", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              id="next"
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              disabled={true}
            >
              Next Lesson
            </LdsButton>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
